<template>
  <div class="invalid-products">
    <img
      src="@/assets/order/invalid-product.svg"
      alt=""
    >
    <div class="text">
      <div class="text-1">
        Invalid products
      </div>
      <div class="text-2">
        This product has been removed.
        <br>
        {{ props.reason || '' }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  reason: {
    type: String,
    required: true
  }
})
</script>

<style lang='less' scoped>
.invalid-products {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 220.5px - 128px);

  .text {
    text-align: center;
    line-height: 24px;
    color: #232323;
    .text-1 {
      font-size: 16px;
      font-family: mon-600;
    }
    .text-2, .text-3 {
      font-size: 14px;
      font-family: mon-500;
    }
    .text-3 {
      color: #F53131;
    }
  }
  .button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 162px;
    height: 40px;
    border-radius: 20px;
    border: 1px solid var(--main-border-color);
    color: #232323;
    font-size: 14px;
    font-family: mon-600;
    margin-top: 16px;
    cursor: pointer;
  }
}
</style>
